export const state = {
    enabled: null,
    notifyOnSnatch: null,
    notifyOnDownload: null,
    notifyOnSubtitleDownload: null,
    dmto: null,
    prefix: null,
    directMessage: null
};

export const mutations = {};

export const getters = {};

export const actions = {};

export default {
    state,
    mutations,
    getters,
    actions
};
